import { render } from "./documents.vue?vue&type=template&id=3181358c&scoped=true&ts=true"
import script from "./documents.vue?vue&type=script&lang=ts"
export * from "./documents.vue?vue&type=script&lang=ts"

import "./documents.vue?vue&type=style&index=0&id=3181358c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3181358c"],['__file',"src/vue/sections-formulaire/documents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3181358c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3181358c', __exports__)) {
    api.reload('3181358c', __exports__)
  }
  
  module.hot.accept("./documents.vue?vue&type=template&id=3181358c&scoped=true&ts=true", () => {
    api.rerender('3181358c', render)
  })

}


export default __exports__